import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'CalendarBooking',
  label: 'Calendar Booking',
  icon: 'DocumentTextIcon',
  description: 'Fields a calendar booking',
  properties: [
    {
      label: 'On Booking Succeeded Sequence Id',
      name: 'onBookingSequenceId',
      editor: 'textbox',
      readonly: false,
      description:
        '(Optional) The ID of an action sequence to run someone successfully books through the calendar',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Calendar Identifier',
      name: 'calendarIdentifier',
      editor: 'textbox',
      readonly: false,
      description:
        'The identifier of the calendar for which to display availability for',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Title',
      name: 'title',
      editor: 'textbox',
      readonly: false,
      description: 'The title of the calendar booking dialog',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Sub-Title',
      name: 'subtitle',
      editor: 'textbox',
      readonly: false,
      description: 'The sub-title of the calendar booking dialog',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Meeting Definition ID',
      name: 'meetingDefinitionId',
      editor: 'textbox',
      readonly: false,
      description:
        'The id of a meeting definition corresponding to the calendar identifier',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Product ID',
      name: 'productId',
      editor: 'textbox',
      readonly: false,
      description: 'The id of a product associated with this booking.',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
